import { render, staticRenderFns } from "./FoodImageModal.vue?vue&type=template&id=e7df5980&"
import script from "./FoodImageModal.vue?vue&type=script&lang=js&"
export * from "./FoodImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports